<div class="search-container">
    <mat-form-field [floatLabel]="'auto'" class="nova__input">
        <input matInput type="text" placeholder="Enter a search..." (keydown.enter)="search()"
            [formControl]="searchControl">
        <button mat-button *ngIf="searchControl.value" matSuffix mat-icon-button aria-label="Clear"
            (click)="searchControl.setValue('')">
            <mat-icon>close</mat-icon>
        </button>
    </mat-form-field>
    <mat-radio-group [formControl]="searchAllFolders">
        <mat-radio-button [value]="false" [disabled]="!selectedFolderId">Selected folder</mat-radio-button>
        <mat-radio-button [value]="true">All folders</mat-radio-button>
    </mat-radio-group>
    <button mat-raised-button color="secondary" (click)="search()">
        Search
    </button>
</div>
<mat-progress-spinner class="spinner" mode="indeterminate" *ngIf="isLoading"></mat-progress-spinner>
